import React from 'react';

class InputError extends React.Component {
    render() {
        const {name, errors} = this.props;
        if (!errors[name]) {
            return '';
        }

        return (
            <label className="error">
                {errors[name]}
            </label>
        );
    }
}

InputError.defaultProps = {
    name: '',
    errors: {}
}

InputError.convertToHasClass = function(errors) {
    if (!errors) {
        return {};
    }
    let result = {};
    for (let [key, error] of Object.entries(errors)) {
        if (Array.isArray(error)) {
            error = error[0];
        }
        result[key] = error ? 'has-danger' : '';
    }
    return result;
}

export default InputError;